(function () {
  var sections = document.querySelectorAll('.oddit-section-benefits-ticker');
  if (!sections.length) return;

  var reducedMotion = window.matchMedia
    ? window.matchMedia('(prefers-reduced-motion: reduce)').matches
    : false;

  sections.forEach(initTicker);

  function initTicker(section) {
    var viewport = section.querySelector('.oddit-section-benefits-ticker__viewport');
    var track = section.querySelector('.oddit-section-benefits-ticker__track');
    if (!viewport || !track) return;

    var baseRow = track.querySelector('.oddit-section-benefits-ticker__row');
    if (!baseRow) return;

    var duration = parseFloat(section.dataset.duration) || 40;
    var pauseOnHover = section.dataset.pauseOnHover === 'true';

    var setWidth = 0;
    var position = 0;
    var lastTimestamp = 0;
    var rafId = null;
    var paused = false;
    var inView = true;

    function clearClones() {
      var clones = track.querySelectorAll('[data-ticker-clone="true"]');
      for (var i = 0; i < clones.length; i++) clones[i].remove();
    }

    function fillTrack() {
      clearClones();
      setWidth = baseRow.getBoundingClientRect().width;
      if (setWidth <= 0) return;

      var viewportWidth = viewport.getBoundingClientRect().width;
      var targetWidth = viewportWidth + setWidth * 2;
      var currentWidth = setWidth;

      while (currentWidth < targetWidth) {
        var clone = baseRow.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.dataset.tickerClone = 'true';
        track.appendChild(clone);
        currentWidth += setWidth;
      }
    }

    function tick(timestamp) {
      if (!lastTimestamp) lastTimestamp = timestamp;
      var delta = timestamp - lastTimestamp;
      lastTimestamp = timestamp;

      if (!paused && inView && setWidth > 0) {
        var pxPerMs = setWidth / (duration * 1000);
        position += pxPerMs * delta;
        if (position >= setWidth) {
          position = position % setWidth;
        }
        track.style.transform = 'translate3d(' + (-position) + 'px, 0, 0)';
      }

      rafId = requestAnimationFrame(tick);
    }

    function start() {
      if (reducedMotion) return;
      fillTrack();
      lastTimestamp = 0;
      if (rafId) cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(tick);
    }

    function remeasure() {
      var ratio = setWidth > 0 ? position / setWidth : 0;
      fillTrack();
      position = ratio * setWidth;
      lastTimestamp = 0;
    }

    if (pauseOnHover) {
      viewport.addEventListener('mouseenter', function () { paused = true; });
      viewport.addEventListener('mouseleave', function () {
        paused = false;
        lastTimestamp = 0;
      });
    }

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        paused = true;
      } else {
        paused = false;
        lastTimestamp = 0;
      }
    });

    if ('ResizeObserver' in window) {
      var resizeRaf = null;
      var ro = new ResizeObserver(function () {
        if (resizeRaf) cancelAnimationFrame(resizeRaf);
        resizeRaf = requestAnimationFrame(remeasure);
      });
      ro.observe(viewport);
    } else {
      window.addEventListener('resize', remeasure);
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        inView = entries[0].isIntersecting;
        if (inView) lastTimestamp = 0;
      }, { rootMargin: '100px' });
      io.observe(section);
    }

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(remeasure);
    }

    var images = baseRow.querySelectorAll('img');
    for (var i = 0; i < images.length; i++) {
      if (!images[i].complete) {
        images[i].addEventListener('load', remeasure, { once: true });
      }
    }

    start();
  }
})();
